import React, { useState } from 'react';
import { Button, Menu, MenuItem } from '@material-ui/core'
import breakpoint from "../helpers/breakpoints";
import { GiHamburgerMenu } from 'react-icons/gi';

const UserMenu = ({ history, currentUser, logout }) => {

    const [anchorEl, setAnchorEl] = useState(false)

    const initials = currentUser && `${currentUser.firstName ? currentUser.firstName[0].toUpperCase() : ''}${currentUser.lastName ? currentUser.lastName[0].toUpperCase() : ''}`
    const role = currentUser?.optional?.role;
    const free = currentUser?.optional?.groups?.some(el => el.includes('FREE'));
    return <div>
        <Button className={`user-menu-button ${anchorEl ? 'user-menu-button-opened' : ''}`}
            aria-controls="user-menu" aria-haspopup="true"
            onClick={(event) => setAnchorEl(event.currentTarget)}>
            {['S', 'XS'].includes(breakpoint()) ? <GiHamburgerMenu /> : initials}
        </Button>
        <Menu
            getContentAnchorEl={null}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            id="user-menu"
            anchorEl={anchorEl}
            style={{ borderRadius: '7px' }}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={(event) => setAnchorEl(null)}
        >
            {['S', 'XS'].includes(breakpoint()) ?
                <div id='menu-nav-items'>
                    <MenuItem className="user-menu-item"
                        onClick={() => {
                            history.push(`/`);
                            setAnchorEl(null);
                        }}>
                        Home
                    </MenuItem>
                    {role || free ?
                        <MenuItem className="user-menu-item"
                            onClick={() => {
                                history.push(`/lessons`);
                                setAnchorEl(null);
                            }}>
                            Courses
                        </MenuItem> : null
                    }
                    {role &&
                        < MenuItem className="user-menu-item"
                            onClick={() => {
                                history.push(`/codewars`);
                                setAnchorEl(null);
                            }}>
                            CodeWars
                        </MenuItem>
                    }
                    {/* {currentUser && currentUser.optional && currentUser.optional.role &&
                        <MenuItem className="user-menu-item"
                            onClick={() => {
                                history.push(`/projects`);
                                setAnchorEl(null);
                            }}>
                            Projects
                        </MenuItem>
                    } */}
                    {role === 'admin' &&
                        <>
                            <MenuItem className="user-menu-item"
                                onClick={() => {
                                    history.push(`/user/search`);
                                    setAnchorEl(null);
                                }}>
                                Users
                        </MenuItem>
                            <MenuItem className="user-menu-item"
                                onClick={() => {
                                    history.push(`/tracking`);
                                    setAnchorEl(null);
                                }}>
                                Tracking
                        </MenuItem>
                        </>
                    }
                </div>
                :
                null
            }
            <MenuItem className="user-menu-item" onClick={() => {
                history.push(`/updateUser/${currentUser.id}`);
                setAnchorEl(null);
            }}>Profile</MenuItem>
            <MenuItem className="user-menu-item" onClick={() => {
                logout();
                setAnchorEl(null);
            }}>Logout</MenuItem>
        </Menu >
    </div >
}

export default UserMenu